import router from "next/router";


function CardHeader({ id, handleCopyLink, iconUrl }) {
    return (
        <div className="flex justify-between items-center mb-3">
            <div className="sm:pl-5"><img src={iconUrl ?? "/accelist-logo.png"} alt="logo" className="max-h-[6rem]" /></div>
            <div className="pr-3 sm:pr-5">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        handleCopyLink(id);
                    }}
                >
                    <img src="/link-share2.svg" alt="share" className="w-5 sm:w-6" />
                </a>
            </div>
        </div>
    );
}

function CardBody({ item, convertDate }) {
    return (
        <div className="px-3">
            <h2 className="sm:text-sm md:text-md lg:text-lg font-medium sm:min-h-[6rem] md:min-h-[3.75rem] lg:min-h-[3rem]">{item.title}</h2>
            <p className="text-xs">{item.city}</p>
            <div className="min-h-[5rem] flex justify-between flex-wrap gap-y-3 pt-5 text-gray-500 ">
                <div className="flex gap-3 items-center">
                    <img
                        src="/business-unit-icon.svg"
                        alt="business unit icon"
                        className="h-6"
                    />
                    <p className="text-xs">{item.businessUnitName}</p>
                </div>
                <div className="flex gap-1 items-center">
                    <img
                        src="/experience-level-icon.svg"
                        alt="experience level icon"
                        className="h-2"
                    />
                    <p className="text-xs">{item.categoryName}</p>
                </div>
            </div>
            <div className="flex text-gray-500 pt-4 mb-2 items-center gap-3">
                <img
                    src="/apply-deadline-clock.svg"
                    alt="deadline icon"
                    className="h-6"
                />
                <p className="text-xs">
                    Apply Deadline : {convertDate(item.endDate)}
                </p>
            </div>
        </div>
    );
}

function CardFooter({ item, handleApplyButtonClick }) {
    return (
        <div className="flex flex-row justify-between items-center pt-4 pb-1 font-semibold">
            <button
                className="w-full text-xs sm:w-auto text-primary rounded-lg 
                px-2 sm:px-7 py-2 sm:mr-2 hover:bg-gray-100 transition duration-200"
                onClick={() => 
                    router.push({
                        pathname: `/vacancy/detail/${item.id}`,
                        query: { isApplied: item.isApplied },
                    })
                }
            >
                See Detail
            </button>
            <button
                onClick={() => handleApplyButtonClick(item)}
                className={`w-full text-xs sm:w-auto rounded-lg px-2 sm:px-7 py-2 sm:mr-2 transition duration-200 
                    ${item.isApplied ? "bg-white text-primary border border-primary" : "bg-primary text-white hover:bg-primary-dark"}`}
                disabled={item.isApplied}
            >
                {item.isApplied == false ? 'Apply' : 'Applied'}
            </button>
        </div>
    );

}

const VacancyCard = ({
    item,
    handleCopyLink,
    convertDate,
    handleApplyButtonClick,
}) => {

    return (
        <div className="block min-w-fit py-1 px-1 sm:px-3 bg-white border-primary border-2 rounded-lg">
            <CardHeader id={item.id} handleCopyLink={handleCopyLink} iconUrl={item.iconUrl} />
            <CardBody item={item} convertDate={convertDate} />
            <hr className="border-t border-2 border-primary" />
            <CardFooter item={item} handleApplyButtonClick={handleApplyButtonClick} />
        </div>
    );
}

export default VacancyCard;